import { render, staticRenderFns } from "./selectPerson.vue?vue&type=template&id=54eb6b17&scoped=true"
import script from "./selectPerson.vue?vue&type=script&lang=js"
export * from "./selectPerson.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=54eb6b17&prod&scoped=true&lang=css&external"
import style1 from "./selectPerson.vue?vue&type=style&index=1&id=54eb6b17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eb6b17",
  null
  
)

export default component.exports